module.exports = __webpack_public_path__ + "static/media/referral-banner.cec49847.svg";